import { Component, HostListener, ChangeDetectorRef, OnInit, AfterViewInit } from '@angular/core';
import { SessionService } from '@app/shared/services/session.service';
import { PortalVersionService } from '@src/app/shared/services/portalVersion.service';

@Component({
    selector: 'app-private-layout',
    templateUrl: './private-layout.component.html',
    styleUrls: ['./private-layout.component.scss'],
    standalone: false
})
export class PrivateLayoutComponent implements OnInit, AfterViewInit {

  portalVersion: string = '';
  displaySidebar: boolean = true;
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkMobileView();
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isMobile && this.displaySidebar) {
      this.closeSidebar();
    }
  }

  constructor(
    public portalVersionService: PortalVersionService,
    public session: SessionService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.checkMobileView();
  }

  ngOnInit(): void {
    this.portalVersionService.getCommit().subscribe(version => {
      this.portalVersion = version
    })
  }

  ngAfterViewInit() {
    this.changeDetector.detectChanges();
  }

  ngOnChanges(): void {
    this.updateBodyScroll();
  }

  ngAfterViewChecked(): void {
    this.updateBodyScroll();
  }

  checkMobileView() {
    this.displaySidebar = window.innerWidth >= 1024;
    this.isMobile = window.innerWidth < 1024;
  }

  toggleSidebar(): void {
    this.displaySidebar = !this.displaySidebar;
  }

  closeSidebar(): void {
    this.displaySidebar = false;
  }

  private updateBodyScroll(): void {
    if (this.isMobile && this.displaySidebar) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
}
